import { combineReducers } from "redux"
import leaderboardByRatingReducer from "./leaderboardByRatingReducer"

export default combineReducers({
    leaderboardData: leaderboardByRatingReducer
})
